import { combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import configureStore from './CreateStore'
import rootSaga from 'Sagas/'
import ReduxPersist from 'Config/ReduxPersist'

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
  auth: require('./AuthRedux').reducer,
  users: require('./UserRedux').reducer,
  teams: require('./TeamRedux').reducer,
  projects: require('./ProjectRedux').reducer,
  collaborators: require('./CollaboratorRedux').reducer,
  videos: require('./VideoRedux').reducer,
  comments: require('./CommentRedux').reducer,
  links: require('./LinkRedux').reducer,
  selections: require('./SelectionRedux').reducer,
  canvas: require('./CanvasRedux').reducer,
  plans: require('./PlanRedux').reducer,
  videoIntegrations: require('./VideoIntegrationRedux').reducer,
  activities: require('./ActivityRedux').reducer
})

const persistConfig = ReduxPersist.storeConfig
let finalReducers = reducers
// If rehydration is on use persistReducer otherwise default combineReducers
if (ReduxPersist.active) {
  finalReducers = persistReducer(persistConfig, reducers)
}
export default () => {
  let { store } = configureStore(finalReducers, rootSaga)
  let persistor = persistStore(store)
  return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/Redux/index.js